import { render } from "./V2StyleBottom.vue?vue&type=template&id=3b480ff2&scoped=true"
import script from "./V2StyleBottom.vue?vue&type=script&lang=js"
export * from "./V2StyleBottom.vue?vue&type=script&lang=js"

import "./V2StyleBottom.vue?vue&type=style&index=0&id=3b480ff2&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b480ff2"]])

export default __exports__